import { render } from "./CenterImage.vue?vue&type=template&id=33419eb7"
const script = {}
script.render = render

export default script